import { today } from '@internationalized/date'

export const presets = {
  today: {
    start: today(),
    end: today(),
  },
  lastWeek: {
    start: today().subtract({ days: 6 }),
    end: today(),
  },
  last2Months: {
    start: today().subtract({ months: 2 }),
    end: today(),
  },
}
